import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import AssignTextMessageDialog, {
  AssignTextMessageDialogCallbackInput,
  AssignTextMessageUniqueProps,
} from '../AssignTextMessageDialog';

const { useDialogForContext, useDialog: useAssignTextMessageDialog } =
  getDialogHooks<
    AssignTextMessageUniqueProps,
    AssignTextMessageDialogCallbackInput
  >(AssignTextMessageDialog);
export const useAssignTextMessageDialogForContext = useDialogForContext;
export default useAssignTextMessageDialog;
